import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.StacklaWidget = class StacklaWidget extends Snappy.BaseComponent {
    /*componentDidMount() {
        this.root.addEventListener('click', () => {
            this.loadWidget(document, 'stackla-widget-js');
        });
    }*/

    loadWidget(d, id) {
        const widgetLoaded = window.Stackla;
        if (widgetLoaded) {
            return;
        }

        /* eslint-disable */
        var t,
            el = d.scripts[d.scripts.length - 1].previousElementSibling;
        if (el) el.dataset.initTimestamp = new Date().getTime();
        if (d.getElementById(id)) return;
        t = d.createElement('script');
        t.src = 'https://assetscdn.stackla.com/media/js/widget/fluid-embed.js';
        t.id = id;
        (d.getElementsByTagName('head')[0] || d.getElementsByTagName('body')[0]).appendChild(t);
        /* eslint-enable */
    }
}

export default Snappy.Component.StacklaWidget;



// WEBPACK FOOTER //
// ./components/cfa-load-stackla-widget/scripts/load-stackla-widget.js